import cn from 'classnames'
import { FC } from 'react'

import { useTranslation } from 'next-i18next'

import styles from './Graph.module.scss'

interface IProps {
  size: 'XS' | 'S' | 'M' | 'L' | 'XL'
  className?: string
  users: string
  year: number
}

const GraphColumn: FC<IProps> = ({ users, year, size = 'small', className }) => {
  const { t } = useTranslation(['stats'])
  return (
    <div className={cn(styles.graphWrapper, styles[size], className)}>
      <div className={styles.graphInfo}>
        <div className={styles.usersCount}>
          <div className={styles.biggerText}>{users}</div>
          {t('stats:ourStoryUsers')}
        </div>
        <div className={styles.year}>
          <div className={styles.biggerText}>{year}</div>
          {t('stats:ourStoryYear')}
        </div>
      </div>
      <div className={cn(styles.graphColumn)}>
        <div className={styles.top} />
        <div className={styles.bot} />
      </div>
    </div>
  )
}

const Graph = () => {
  return (
    <div className={styles.graph}>
      <GraphColumn users="3 924 918" year={2022} className={styles.fifth} size="XL" />
      <GraphColumn users="2 252 721" year={2021} className={styles.fourth} size="L" />
      <GraphColumn users="1 864 639" year={2020} className={styles.third} size="M" />
      <GraphColumn users="120 808" year={2019} className={styles.second} size="S" />
      <GraphColumn users="54 402" year={2018} className={styles.first} size="XS" />
    </div>
  )
}

export default Graph
